
// requiring html templates so that hot reloading works
const template = require('./sideMenu.html');

const NS = 'SideMenu'; // jshint ignore:line

export default function SideMenu($rootScope, $state, unregister) { // as sideMenu
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    controllerAs: 'sideMenu',
    template,
    scope: {
      pages: '='
    },
    controller
  };

  function controller($scope) {
    "ngInject";

    var vm = this;
    //-- define public properties
    vm.selectedPage = null;
    //-- define public methods
    vm.openPage = openPage;
    //-- listen
    var listeners = [];
    listeners.push($rootScope.$on('$stateChangeSuccess', checkSelected));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    //-- init
    checkSelected();

    function checkSelected() {
      if (vm.selectedPage) {
        vm.selectedPage.cls = '';
      }
      // select the current page
      for (var i = $scope.pages.length - 1; i >= 0; i--) {
        var page = $scope.pages[i];
        if ($state.current.name.indexOf(page.path + ".") !== -1 || $state.current.name === page.path) {
          page.cls = 'selected';
          vm.selectedPage = page;
        }
      }
    }

    function openPage(page) {
      $state.go(page.path);
    }
  }
}
